const jobs = {
  bulk: {

    table: {
      direction: {
        distribute: 'To School',
        collect: 'From School',
        both: 'To School & From School',
      },

    },

    direction: {
      to: 'To School',
      from: 'From School',
      both: 'To School & From School',
    },

    form: {
      information: {
        details: {
          fields: {
            fromHour: 'School Starts at',
            toHour: 'School Ends at',
            shift: 'School hours',
            from: 'Home',
            to: 'School',
          },
        },
        locations: {
          header: 'Schools',
          fields: {
            locations: 'Select School'
          }
        },
      },

    },
  },

  forms: {
    information: {
      passengers: {
        header: 'Personal Information',
        label: 'Select Students'
      },
    }
  }
};

export default jobs;
